import { APIv4 as API } from 'src/libs/axios';
import { alertError } from 'src/libs/toastify';

const Messages = {
  FETCH_SUPPLIERS: 'Ошибка получения списка поставщиков',
  FETCH_SUPPLIER: 'Ошибка получения данных поставщика',
  CREATE_SUPPLIER: 'Ошибка создания поставщика',
  UPDATE_SUPPLIER: 'Ошибка обновления поставщика',
};

export type SupplierListItem = {
  id: string;
  name: string | null;
  inn: string | null;
  kpp: string | null;
  phone: string | null;
  email: string | null;
  isActive: boolean;
};

export type SupplierDetail = SupplierListItem;

export type SupplierPayload = {
  name: string;
  inn: string;
  kpp: string | null;
  phone: string | null;
  email: string | null;
  isActive: boolean;
};

export type SupplierValues = {
  name: string;
  inn: string;
  kpp: string;
  phone: string;
  email: string;
  isActive: boolean;
};

export type SupplierSearchParams = {
  search?: string;
  isActive?: boolean;
};

const BASE_URL = '/back-office/suppliers';

const adaptSupplier = (values: SupplierValues): SupplierPayload => ({
  name: values.name.trim(),
  inn: values.inn.trim(),
  kpp: values.kpp.trim() || null,
  phone: values.phone.trim() || null,
  email: values.email.trim() || null,
  isActive: values.isActive,
});

export const mapSupplierToValues = (
  data: SupplierListItem
): SupplierValues => ({
  name: data.name ?? '',
  inn: data.inn ?? '',
  kpp: data.kpp ?? '',
  phone: data.phone ?? '',
  email: data.email ?? '',
  isActive: data.isActive,
});

export const fetchAllSuppliers = (
  params?: SupplierSearchParams
): Promise<SupplierListItem[] | void> =>
  API.get<SupplierListItem[]>(BASE_URL, { params })
    .then(({ data }) => data)
    .catch((err) => alertError(err, Messages.FETCH_SUPPLIERS));

export const fetchSupplier = ({
  id,
}: {
  id: string;
}): Promise<SupplierDetail | void> =>
  API.get<SupplierDetail>(`${BASE_URL}/${id}`)
    .then(({ data }) => data)
    .catch((err) => alertError(err, Messages.FETCH_SUPPLIER));

export const addSupplier = (data: SupplierValues): Promise<string> =>
  API.post<string>(BASE_URL, adaptSupplier(data)).then(({ data }) => data);

export const updateSupplier = (params: {
  id: string;
  data: SupplierValues;
}): Promise<boolean> =>
  API.put(`${BASE_URL}/${params.id}`, adaptSupplier(params.data)).then(
    ({ data }) => Boolean(data)
  );
